<template>
  <div style="margin-top: 20px;">
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="isCancelOne">
      <el-tab-pane :label="$t('listOfSet.tabulation')" name="tabsTable">
        <keysetPage v-if="tabsName === 'tabsTable'" :dataIdOne="dataId"></keysetPage>
      </el-tab-pane>
      <el-tab-pane :label="$t('listOfSet.form')" name="tabsForm">
        <formSetPage v-if="tabsName === 'tabsForm'" :dataIdTwo="dataId" :isString="true"></formSetPage>
      </el-tab-pane>
      <el-tab-pane :label="$t('listOfSet.codeEvent')" name="tabsCodeEvent">
        <codeEventSet v-if="tabsName === 'tabsCodeEvent'" :dataIdThree="dataId"></codeEventSet>
      </el-tab-pane>
      <el-tab-pane :label="$t('listOfSet.Language')" name="tabsLanguage">
        <languageSet v-if="tabsName === 'tabsLanguage'" :dataIdFour="dataId" :typeFour="dataType"></languageSet>
      </el-tab-pane>
      <el-tab-pane :label="$t('listOfSet.attachmentType')" name="tabsAttachmentType">
        <attachmentType v-if="tabsName === 'tabsAttachmentType'" :dataIdSix="dataId"></attachmentType>
      </el-tab-pane>
      <el-tab-pane :label="$t('listOfSet.sheetPage')" name="tabsSheet">
        <sheetPage v-if="tabsName === 'tabsSheet'" :dataIdFive="dataId"></sheetPage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import keysetPage from '../../keySet/index.vue'
import formSetPage from '../../FormSet/index.vue'
import codeEventSet from '../../codeEvent/index.vue'
import languageSet from '../../LanguageSet/index.vue'
import attachmentType from '../../attachmentType/index.vue'
import sheetPage from '../../sheetSet/index.vue'
export default {
  name: "tabsDemo",
  components: { keysetPage, formSetPage, codeEventSet, languageSet, sheetPage, attachmentType },
  props: {
    listDataId: {
      type: String,
      default: ''
    },
    isCancel: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    listDataId: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    },
    isCancel: {
      handler(newVal, oldVal) {
        this.isCancelOne = newVal
      }, deep: true, immediate: true
    }
  },
  data() {
    return {
      dataId: '',
      dataType: 0,
      tabsName: 'tabsTable',
      activeName: "tabsTable",
      isCancelOne: null
    };
  },
  methods: {
    handleClick(tab, event) {
      switch (tab._props.name) {
        case tab._props.name:
          this.tabsName = tab._props.name
          break;
      }
    },
  },
};
</script>
